import {wordbank} from "./wordbank";
export const Matrix = [
    ["", "", "", "", ""],
    ["", "", "", "", ""],
    ["", "", "", "", ""],
    ["", "", "", "", ""],
    ["", "", "", "", ""],
    ["", "", "", "", ""]
]


export const generateWordSet = async () => {
    let wordSet = new Set(wordbank)
    let todaysWord;
    await fetch(wordbank)
        .then((res) => res.text)
            todaysWord = wordbank[Math.floor(Math.random() * wordbank.length)]
    return {wordSet, todaysWord}

}





